// @todo Add label hover input focus(+on autocomplete field)
NtechApp.SelectForm = function($selectInput) {
    var me = this;

    me._sizesResolver = new NtechApp.SizesResolver();
    me._click = new NtechApp.TouchClickEvent();
    me._overlay = new NtechApp.Overlay();

    me._$selectInputWrapper = null;
    me._$selectInput = $selectInput;
    me._$selectInputOverlay = null;
    me._$selectInputArrow = null;
    me._$form = null;

    this._onTimeout = null;
    this._offTimeout = null;

    this._originalPlaceholder = null;
    this._loader = null;
    this._loaderOverlay = null;

    if(NtechApp.dom.hasAttribute(this._$selectInput.get(0), "data-customMultipleSelect"))
        this._select = new NtechApp.MultipleSelectForm(this);
    else
        this._select = new NtechApp.SingleSelectForm(this);

    this._create(this._select.getFormHtml(this._getSelectLabel()));
    this._adjustInputAttrs();
    this._loader = new NtechApp.Loader(25, 25, "absolute", this._$selectInputOverlay);
    this._loaderOverlay = new NtechApp.Overlay(
        this._$selectInputOverlay, {position: "absolute", height: "100% !important"}
    );
    this._syncLock();

    this._restrictLabelUpdates = false;

    return this;
};

NtechApp.SelectForm.EVENT_OPTION_SELECT = "NtechApp.SelectForm.EventOptionSelect";

NtechApp.proto(NtechApp.SelectForm, {
    setOverlayCss: function(newCss) { this._overlay.updateCss(newCss); },
    getSelectInputWrapper: function() { return this._$selectInputWrapper; },
    getSelectInput: function() { return this._$selectInput; },
    getHiddenInput: function() {
        var sel = this._$selectInput.attr("data-customselectid");
        return this._$selectInputWrapper.parent().find("[data-customSelectHiddenId=" + sel + "]");
    },
    getSelectedOption: function() {
        var $option = this._$form.find("[data-optionValue='" + this.getVal() + "']");
        return $option;
    },
    getSelectedOptionIndex: function() {
        var $selectedOption = this.getSelectedOption();
        if($selectedOption.length == 0)
            return -1;

        var index = this._$form.find("[data-optionValue]").index($selectedOption);
        return index;
    },
    getVal: function() { return this.getHiddenInput().val(); },
    getLabel: function() { return this._$selectInput.val(); },
    getClick: function() { return this._click; },
    getForm: function() { return this._$form; },
    getView: function() { return this._$selectInputWrapper; },

    restrictLabelUpdates: function() { this._restrictLabelUpdates = true; },
    areLabelUpdatesRestricted: function() { return this._restrictLabelUpdates; },

    _getSelectLabel: function() {
        if(NtechApp.dom.hasAttribute(this._$selectInput.get(0), "data-customSelectLabel"))
            var selectLabel = this._$selectInput.attr("data-customSelectLabel");
        else
            var selectLabel = "Select value";

        return selectLabel;
    },

    _create: function(formHtml) {
        this._$selectInput.wrap("<div/>");
        this._$selectInputWrapper = this._$selectInput.parent();
        this._$selectInputWrapper.addClass("selectInputWrapper");
        this._$selectInputWrapper.css({
            position: "relative",
            zIndex: "1"
        });

        this._$selectInput.css({zIndex: "1"});

        this._$selectInputOverlay = $("<div/>").addClass("selectInputOverlay");
        this._$selectInputOverlay.css({
            position: "absolute",
            left: "0px",
            top: "0px",
            width: "100%",
            height: "100%",
            zIndex: "2"
        });
        this._$selectInputWrapper.append(this._$selectInputOverlay);

        this._$selectInputArrow = $("<div/>").addClass("selectArrow");
        this._$selectInputArrow.css({
            position: "absolute",
            zIndex: "3",
            right: "0px",
            top: "0px",
            width: "20px",
            height: "100%"
        });
        this._$selectInputWrapper.append(this._$selectInputArrow);

        this._$form = $($.parseHTML(formHtml));
        this._$form.css({zIndex: "1201"});

        this._insert();
        this._insertOptions();
        this._select.afterInsert();
        this._bindEvents();

        if(NtechApp.dom.hasAttribute(this._$selectInput.get(0), "data-selectFormClass")) {
            var additionalClass = this._$selectInput.attr("data-selectFormClass");
            var currentClass = this._$form.attr("class");
            var newClass = currentClass + " " + additionalClass;

            this._$form.attr("class", newClass);
        }
    },

    _insert: function() {
        $("body").append(this._$form);
        // Apply transform per item right after append
        this._sizesResolver.getComputedCss(this._$form).transform;
    },

    _insertOptions: function() {
        var me = this;
        var labels = this._$selectInput.attr("data-selectLabels").split(",");
        var vals = this._$selectInput.attr("data-selectVals").split(",");
        //this._$selectInput.val(this._$selectInput.attr("data-selectSelected"));

        for(var i = 0; i < labels.length; i++) {
            var $option = $("<div/>").addClass("selectOption");
            $option.attr("data-optionValue", vals[i]);
            $option.text(labels[i]);

            me._$form.find(".scrollableFormContent").append($option);
        }
    },

    _bindEvents: function() {
        var me = this;
        NtechApp.lockScroll(this._$form.find(".scrollableFormContent"));

        this._click.listen(this._$form.find(".close"), function() {
            me.off();
        });

        this._select.bindEvents();
    },

    _adjustInputAttrs: function() {
        this._$selectInput.removeAttr("id");
        this._$selectInput.removeAttr("name");
    },

    _syncLock: function() {
        if (NtechApp.dom.hasAttribute(this._$selectInput.get(0), "data-lockedSelect"))
            this.lock();
    },

    lock: function() {
        this._originalPlaceholder = this._$selectInput.attr("placeholder");
        if(NtechApp.dom.hasAttribute(this._$selectInput.get(0), "data-lockedSelectPlaceholder")) {
            var placeholder = this._$selectInput.attr("data-lockedSelectPlaceholder");
            this._$selectInput.attr("placeholder", placeholder);
        }

        this._$selectInput.attr("data-lockedSelect", "e");
    },

    unlock: function() {
        this._$selectInput.attr("placeholder", this._originalPlaceholder);
        this._$selectInput.removeAttr("data-lockedSelect");
    },

    simpleUnlock: function() {
        this._$selectInput.removeAttr("data-lockedSelect");
    },

    clearVal: function(inputLabel) {
        var me = this;
        var inputLabel = inputLabel || "";

        this._$selectInput.val(inputLabel);
        //this._$selectInput.attr("data-selectSelected", "");

        if(NtechApp.dom.hasAttribute(me._$selectInput.get(0), "data-customSelectId")) {
            var hid = me._$selectInput.attr("data-customSelectId");
            var hattr = "[data-customSelectHiddenId=" + hid + "]";
            var $hiddenSelectInput = me._$selectInputWrapper.parent().find(hattr);

            $hiddenSelectInput.val("");
        }
    },

    enableLoader: function() {
        this._loader.on();
        this._loaderOverlay.on();
    },

    disableLoader: function() {
        this._loader.off();
        this._loaderOverlay.off();
    },

    reinsertOptions: function(labels, vals) {
        this._$form.find(".selectOption").remove();
        this._$selectInput.attr("data-selectLabels", labels.join(","));
        this._$selectInput.attr("data-selectVals", vals.join(","));

        this._insertOptions();
    },

    on: function() {
        var me = this;
        this._select.beforeOn();

        if(NtechApp.dom.hasAttribute(me._$selectInput.get(0), "data-lockedSelect")) {
            if(NtechApp.dom.hasAttribute(me._$selectInput.get(0), "data-lockedSelectMsg"))
                NtechApp.info.on(me._$selectInput.attr("data-lockedSelectMsg"));
            return;
        }

        clearTimeout(this._offTimeout);
        clearTimeout(this._onTimeout);

        this._overlay.on();
        this._$form.css("display", "block");

        this._onTimeout = setTimeout(function() {
            me._$form.addClass("visible");
        }, 20);
    },

    off: function() {
        var me = this;
        clearTimeout(this._onTimeout);
        clearTimeout(this._offTimeout);

        this._overlay.off();
        this._$form.removeClass("visible");

        this._offTimeout = setTimeout(function() {
            me._$form.css("display", "none");
        }, 400);
    }
});